import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ParsingOverlay',
  props: {
    title: { default: 'Processing data' },
    message: { default: 'Please wait...' },
    duration: { default: 1500 }
  },
  emits: ["complete"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'complete'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, message: string, duration: number };

const { proxy } = getCurrentInstance()!;





const progress = ref(0);
const statusText = ref(proxy?.$t('Reading data...') as string);
let animationFrame: number;
let startTime: number;

const STATUS_MESSAGES = [
    proxy?.$t('Reading data...') as string,
    proxy?.$t('Formatting cells...') as string,
    proxy?.$t('Finishing up...') as string,
];

function animate(timestamp: number) {
    if (!startTime) {
        startTime = timestamp;
    }

    const elapsed = timestamp - startTime;
    const rawProgress = Math.min((elapsed / props.duration) * 100, 100);

    // Ease out cubic for smoother animation
    progress.value = 100 - Math.pow(1 - rawProgress / 100, 3) * 100;

    // Update status text based on progress
    const statusIndex = Math.min(
        Math.floor((progress.value / 100) * STATUS_MESSAGES.length),
        STATUS_MESSAGES.length - 1,
    );
    statusText.value = STATUS_MESSAGES[statusIndex];

    if (progress.value < 100) {
        animationFrame = requestAnimationFrame(animate);
    } else {
        emit('complete');
    }
}

onMounted(() => {
    animationFrame = requestAnimationFrame(animate);
});

onBeforeUnmount(() => {
    if (animationFrame) {
        cancelAnimationFrame(animationFrame);
    }
});

return { __sfc: true,proxy, props, emit, progress, statusText, animationFrame, startTime, STATUS_MESSAGES, animate }
}

})